var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[(_vm.$root.inProfileCartMode)?_c('RowMinus',{attrs:{"rowConfig":_vm.rowConfig}}):_vm._e(),_vm._v(" "),_c('td',{staticClass:"name-column"},[_vm._v(_vm._s(_vm.rowConfig.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }